var map = {
	"./1.png": "e4d3",
	"./2.png": "8c82",
	"./3.png": "7622",
	"./4.png": "39c2",
	"./5.png": "f084",
	"./client.png": "3d15",
	"./customize-bg.png": "9a37",
	"./process-xs.en.png": "2dca",
	"./process-xs.png": "179e",
	"./process.en.png": "cf3a",
	"./process.png": "40dd",
	"./tagging.png": "bbcb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "277a";